module.exports = __webpack_public_path__ + "img/order12.c5eb9796.svg";